<template>
  <div class='accounting-system-settings-overlay'>
    <ed-input type="text"
              v-if="this.accountSettings.ShowAccountOrGlCode"
              v-model="accountOrGlCode"
              :required="pushToAccountingSystem"
              validation
              @validate='save'
              :error="error"
              @input="(o) => { accountOrGlCode = o; }"
              field-label="Account/Gl Code">
    </ed-input>

    <label>PSL+ Vendor</label>
    <div style="display: flex;">
      <input type="checkbox" v-model="pushToAccountingSystem" id="push-to-accounting-system">
      <label for="push-to-accounting-system" style="margin-left: 7px; margin-top: 3px;">Sync Card data with PSL+</label>
    </div>

    <br>
    <ed-input type="text"
              v-model="cardNumberInAccountingSystem"
              @input="(o) => { cardNumberInAccountingSystem = o; }"
              maxlength="6"
              field-label="PSL+ Card Number">
      <div slot="additionalText" style="font-size: smaller; font-style: italic;">
        If vendor record is already in PSL+, please enter as displayed in PSL+
      </div>
    </ed-input>
  </div>
</template>

<script>
export default {
  props: {
    card: Object,
    accountSettings: Object
  },

  computed: {
  },

  methods: {
    async save() {
      this.accountOrGlCode = (this.accountOrGlCode || '').trim()
      if (this.pushToAccountingSystem) {
        this.accountOrGlCode = (this.accountOrGlCode || '').trim()
        if (!this.accountOrGlCode.trim()) {
          this.error = true
          return false
        } else {
          this.error = false
        }
      }

      if (this.card.Id) {
        try {
          const response = await this.api.patch(`evedpaycards/${this.card.Id}/accounting-system-settings`, {
            AccountOrGlCode: this.accountOrGlCode,
            PushToAccountingSystem: this.pushToAccountingSystem,
            CardNumberInAccountingSystem: this.cardNumberInAccountingSystem
          })
          if (response.status === 200) {
            this.card.AccountOrGlCode = this.accountOrGlCode
            this.card.CardNumberInAccountingSystem = this.cardNumberInAccountingSystem
            return true
          } else {
            console.log(response)
          }
        } catch (error) {
          console.log(error)
        }
        return false
      }
    }
  },

  data() {
    return {
      accountOrGlCode: this.card.AccountOrGlCode,
      cardNumberInAccountingSystem: this.card.CardNumberInAccountingSystem,
      pushToAccountingSystem: false,
      error: false,
      errorMessage: 'Required'
    }
  }
}
</script>

<style lang='scss' scoped>

  .accounting-system-settings-overlay label {
    margin-bottom: 0;
  }

  .accounting-system-settings-overlay input[type="checkbox"] + label {
    font-weight: 300;
  }

  .error-message {
    color: red;
    font-size: 0.8em;
  }

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/AccountingSystemSettings.vue